<template>
  <Dialog v-if="isActive" v-show="isActive" class="backdrop-blur-sm" :extend-class="['md:max-w-3xl mb-[2rem]']">
    <div class="bg-white rounded-lg w-full">
      <div class="p-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-3xl font-medium">{{ actionType == 'add' ? 'Add' : 'Edit' }} experience</h2>
          <img src="@/assets/icons/times.svg" class="w-4 cursor-pointer" alt="" @click="$emit('close')" />
        </div>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2 mb-4">
          <div>
            <label for="" class="block text-md font-albert text-brand-black/70 mb-2">Start Date</label>
            <VueDatePicker v-model="position.start_date"></VueDatePicker>
          </div>

          <div>
            <label for="" class="block text-md font-albert text-brand-black/70 mb-2">End Date</label>
            <VueDatePicker v-model="position.end_date"></VueDatePicker>
          </div>

          <div>
            <Input type="text" label="Employer" placeholder="Employer name" v-model="position.company_name" />
          </div>

          <div>
            <Input type="text" label="Country" placeholder="Select" v-model="position.country" />
          </div>

          <div>
            <Input type="text" label="Job title" placeholder="Enter role title name" v-model="position.position_name" />
          </div>

          <div>
            <Input type="text" label="Employment type" placeholder="Select" />
          </div>
        </div>

        <div class="mb-6">
          <Input type="textarea" label="Description" placeholder="Select" v-model="position.job_details" />
        </div>

        <div class="flex justify-end">
          <Button data-test="login-button" label="Save" color="primary" type="button" class="px-8 rounded-xl" @click="$emit('confirm')" />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '@/components/Dialog.vue';
import { onMounted } from 'vue';
import Input from '../form/Input.vue';
import Button from '../Button.vue';

const props = defineProps({
  isActive: { type: Boolean, default: false },
  position: { type: Object },
  actionType: { type: String, default: 'add' },
});

onMounted(() => {});
</script>
